import * as React from 'react';
import { OtherDevelopersWrapper } from '../../components/OtherDevelopersRedesigned';
import { useSelector } from 'react-redux';
import { getOtherDevelopers } from '../../selectors/developerV2/getOtherDevelopers';
import { OtherDeveloperCard } from '../../components/OtherDevelopersRedesigned/OtherDeveloperCard';

export const OtherDevelopers = () => {
  const developers = useSelector(getOtherDevelopers);

  return (
    <OtherDevelopersWrapper>
      {developers.map(developer => (
        <OtherDeveloperCard
          key={developer.id}
          logo={developer.logo}
          rate={developer.rating}
          name={developer.name}
          url={developer.url}
          readyHouses={developer.readyHouses}
          housesInProcess={developer.housesInProcess}
        />
      ))}
    </OtherDevelopersWrapper>
  );
};
